export default "__VITE_ASSET__f43d429d__"